<div *ngFor="let correspondence of correspondenceList">
  <a href="{{downLoadDocumentUrl + correspondence?.itemId}}" class="download" target="_blank">
    <button nxPlainButton type="button" class="nx-margin-right-m">
      <nx-icon name="download" class="nx-margin-right-2xs"></nx-icon>{{correspondence?.subclassidLabel}}
    </button>
  </a>
</div>
